import { useEffect, useState } from "react";
import api from "@/api";
import { ROLE_LABELS } from "@/auth";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { Check, X, Clock } from "lucide-react";

export default function LinkApprovalsPage() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/links", { params: { status: "pending" } });
      setList(r.data);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const approve = async (id) => {
    try {
      await api.post(`/links/${id}/approve`, {});
      toast.success("Enlace aprobado");
      load();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error");
    }
  };
  const reject = async (id) => {
    try {
      await api.post(`/links/${id}/reject`, {});
      toast.success("Enlace rechazado");
      load();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error");
    }
  };

  return (
    <div className="space-y-6" data-testid="approvals-page">
      <div>
        <span className="tracking-label text-blue-700">Bandeja</span>
        <h1 className="mt-2 font-display font-black text-3xl text-slate-900">Aprobaciones pendientes</h1>
        <p className="text-sm text-slate-600 mt-1">
          Revisa y aprueba los enlaces de reclutamiento. Cada acción queda registrada con tu nombre, fecha y hora.
        </p>
      </div>
      <div className="surface-card overflow-hidden">
        {loading ? (
          <div className="p-8 text-slate-500 text-center">Cargando…</div>
        ) : list.length === 0 ? (
          <div className="p-12 text-center">
            <Clock className="w-10 h-10 mx-auto text-slate-400" />
            <p className="mt-3 text-slate-600">No hay enlaces pendientes.</p>
          </div>
        ) : (
          <div className="divide-y divide-slate-200">
            {list.map((l) => (
              <div key={l.id} className="px-6 py-4 flex flex-col md:flex-row md:items-center md:justify-between gap-3" data-testid={`approval-row-${l.id}`}>
                <div>
                  <div className="flex items-center gap-2 flex-wrap">
                    <Badge variant="outline" className="uppercase tracking-wider text-[10px]">{ROLE_LABELS[l.target_role]}</Badge>
                    <span className="font-medium text-slate-900">{l.target_region_name}</span>
                    {l.municipio_nombre && <span className="text-xs text-slate-500">· {l.municipio_nombre}</span>}
                  </div>
                  <div className="mt-1.5 text-xs text-slate-600">
                    Solicitado por <strong>{l.generated_by_name}</strong> ({ROLE_LABELS[l.generated_by_role]}) el {new Date(l.created_at).toLocaleString("es-MX")}
                  </div>
                  {l.notes && <div className="mt-1 text-xs text-slate-500 italic">"{l.notes}"</div>}
                </div>
                <div className="flex gap-2 shrink-0">
                  <Button size="sm" className="bg-green-600 hover:bg-green-700 text-white" onClick={() => approve(l.id)} data-testid={`approval-approve-${l.id}`}>
                    <Check className="w-4 h-4 mr-1" /> Aprobar
                  </Button>
                  <Button size="sm" variant="outline" className="border-red-300 text-red-700 hover:bg-red-50" onClick={() => reject(l.id)} data-testid={`approval-reject-${l.id}`}>
                    <X className="w-4 h-4 mr-1" /> Rechazar
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
